<app-modal-window title="Укажите причину"
                  [actions]="true"
                  [disabledConfirm]="withDrawLimitForm.invalid"
                  (close)="close()"
                  (confirm)="setStoreWithdrawLimit()">
  <form class="withdraw-limit-form" [formGroup]="withDrawLimitForm">
    <mat-form-field appearance="outline" class="withdraw-limit">
      <mat-label>Сумма</mat-label>
      <input matInput type="number" id="amount" formControlName="withdrawLimit">
      <span class="visual-usd">{{this.withDrawLimitForm.get('withdrawLimit').value | fastCoinsToDollar}}</span>
    </mat-form-field>

    <mat-form-field appearance='outline' class="reason">
      <mat-label>Причина</mat-label>
      <input matInput type='text' placeholder='Причина' formControlName='reason'>
    </mat-form-field>
  </form>
</app-modal-window>
